/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchTestItem } from '../../models/match-test-item';

export interface UpdateStudentProfileMatchTestItems$Params {
  profileId: string;
      body?: Array<MatchTestItem>
}

export function updateStudentProfileMatchTestItems(http: HttpClient, rootUrl: string, params: UpdateStudentProfileMatchTestItems$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateStudentProfileMatchTestItems.PATH, 'put');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateStudentProfileMatchTestItems.PATH = '/studentprofile/{profileId}/matchtest';
